import { MeasurerSystem } from '../typings/common';

export const GET_USER_SETTINGS_DATA = 'GET_USER_SETTINGS_DATA';
export type GET_USER_SETTINGS_DATA = typeof GET_USER_SETTINGS_DATA;

export interface GetUserSettingsAction {
    type: GET_USER_SETTINGS_DATA;
}

export function getUserSettingsData(): GetUserSettingsAction {
    return {
        type: GET_USER_SETTINGS_DATA
    };
}

export const UPDATE_USER_SETTINGS_DATA = 'UPDATE_USER_SETTINGS_DATA';
export type UPDATE_USER_SETTINGS_DATA = typeof UPDATE_USER_SETTINGS_DATA;

export interface UpdateUserSettingsAction {
    type: UPDATE_USER_SETTINGS_DATA;
    measurerAccounts: MeasurerSystem[];
}

export function updateUserSettingsData(measurerAccounts: MeasurerSystem[]): UpdateUserSettingsAction {
    return {
        type: UPDATE_USER_SETTINGS_DATA,
        measurerAccounts
    };
}

export const LOGIN_TO_MEDIASCOPE = 'LOGIN_TO_MEDIASCOPE';
export type LOGIN_TO_MEDIASCOPE = typeof LOGIN_TO_MEDIASCOPE;

export interface LoginToMediascope {
    type: LOGIN_TO_MEDIASCOPE;
}

export function loginToMediascope(): LoginToMediascope {
    return {
        type: LOGIN_TO_MEDIASCOPE
    };
}

export const LOGOUT_FROM_MEDIASCOPE = 'LOGOUT_FROM_MEDIASCOPE';
export type LOGOUT_FROM_MEDIASCOPE = typeof LOGOUT_FROM_MEDIASCOPE;

export interface LogoutFromMediascope {
    type: LOGOUT_FROM_MEDIASCOPE;
}

export function logoutFromMediascope(): LogoutFromMediascope {
    return {
        type: LOGOUT_FROM_MEDIASCOPE
    };
}

export type UserSettingsAction =
    | GetUserSettingsAction
    | UpdateUserSettingsAction
    | LoginToMediascope
    | LogoutFromMediascope;
